import { IApolloSearchPartnersResult } from 'legacy/lut/classes/models/apollo'

import WebSocketStore from 'core/classes/services/WebSocketStore'
import { TResponse } from 'core/classes/ws/WebSocketClient'
import { isInstanceOf } from 'core/utils/functions'
import { IResponseErrorPayload } from 'onboarding/types/response'
import {
  throwOnErrorWithoutPayload,
  throwOnInvalidRequestParams,
} from 'onboarding/utils/errorResponse/throwOnApiError'

import { IApolloSearchGuestParameters } from '../classes/models/iApolloSearchGuest'

type TErrorResponse = TResponse<{
  errorPayload?: IResponseErrorPayload | undefined
  error?: any
}>

class ApolloApi {
  public async search(
    payload: IApolloSearchGuestParameters
  ): Promise<IApolloSearchPartnersResult[]> {
    const wsClient = WebSocketStore.get('onboarding')

    // todo: must return { items: IApolloSearchPartnersResult[]; errorPayload?: IResponseErrorPayload }
    const response = await wsClient.call<
      | IApolloSearchPartnersResult[]
      | {
          errorPayload?: IResponseErrorPayload
          error?: any
        }
    >({
      service: 'apollo',
      action: 'search',
      payload,
      returnError: true,
      withoutTokenRefresh: true,
      isAuth: true,
    })
    if (
      response.status !== 'success' &&
      isInstanceOf<TErrorResponse>(response, (o) => 'errorPayload' in o.data || 'error' in o.data)
    ) {
      throwOnInvalidRequestParams(response)
      throwOnErrorWithoutPayload(response, 'Error')
    }

    // todo: must return response.data.items
    // Until that contract lands, the answer is checked rather than cast. The cast this
    // replaced let a non-array through, and the failure surfaced far from here as
    // `apolloSearchResult.map is not a function` inside the duplicates mapper. All three
    // callers wrap this call and hand the error to showErrorOnCatch, so a thrown one is
    // shown to the user instead.
    if (!Array.isArray(response.data)) {
      throw new Error('Apollo search did not return a list of matches')
    }

    return response.data
  }
}

export const apolloApi = new ApolloApi()
